<section class="file-upload-wrapper">
  <button
    class="tt--button button--blue large"
    appLoadingState
    [loadingOnClick]="false"
    [loadingState]="processingState"
    (click)="selectUploadFile()">
    {{ label }}
    <!-- images for profile and docuements.  PDF for documents-->
    <input #inputFile type="file" accept="image/*,application/pdf" (change)="uploadFileOnChange($event)"/>
  </button>
  @if (showMessages && messageInfo && (messageInfo.message && messageInfo.type)) {
    <div class="message"
      [ngClass]="{'success': messageInfo.type === 'success', 'error': messageInfo.type === 'error'}"
      >
      <i class="fa fa-info-circle"></i>
      <span class="info">{{ messageInfo.message }}</span>
    </div>
  }
  @if (showDescription) {
    <p class="description">
      {{ description }}
    </p>
  }
</section>